// Product tiers (v1.3.4) — the card cap each plan allows.
//
// KEEP IN SYNC with planLimit() in firestore.rules and the PLANS map in
// scripts/set-tier.js. The rules are the real enforcement; this file drives the UI
// (friendly pre-checks, the Settings plan card). Spec: docs/03_Security/Tiers and Entitlements.md
export const TIERS = {
  low:     { key: 'low',     label: 'Low',     cardLimit: 50,  note: 'Free plan' },
  med:     { key: 'med',     label: 'Medium',  cardLimit: 110, note: '' },
  high:    { key: 'high',    label: 'High',    cardLimit: 200, note: '' },
  founder: { key: 'founder', label: 'Founder', cardLimit: 350, note: 'Invite only' },
};

// Every account without an entitlement doc (and signed-out guests) is on the free Low tier.
export const DEFAULT_PLAN = 'low';

// Unknown / malformed plan names fall back to the default — same as planLimit() in the rules.
export const getTier = (plan) => TIERS[plan] || TIERS[DEFAULT_PLAN];

// Remaining slots, never negative (an account can sit above its cap after a downgrade).
export const cardsRemaining = (used, tier) => Math.max(0, tier.cardLimit - used);
